;(() => {
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  const seen = new WeakSet();

  function getPayload(el){
    const id   = el.getAttribute('data-promotion-id')   || '';
    const name = el.getAttribute('data-promotion-name') || '';
    const cnam = el.getAttribute('data-creative-name')  || '';
    const cslot= el.getAttribute('data-creative-slot')  || '';
    const loc  = el.getAttribute('data-location-id')    || '';
    const ptype= el.getAttribute('data-page-type')      || '';
    const dest = el.getAttribute('data-dest')           || '';

    // GA4 ecommerce expects an items[] array. We also pass top-level fields for convenience.
    const item = {
      item_id: id || name || '(internal-ad)',   // safe fallback
      item_name: name || '(Internal Ad)',
      creative_name: cnam || 'internal-ad',
      creative_slot: cslot || 'r2-internal-ad',
      promotion_id: id || undefined,
      promotion_name: name || undefined,
      location_id: loc || undefined
    };

    return {
      promotion_id: id,
      promotion_name: name,
      creative_name: cnam,
      creative_slot: cslot,
      location_id: loc,
      page_type: ptype,
      destination: dest,
      items: [item]
    };
  }

  function trackGA4(eventName, payload, cb){
    // Prefer gtag if available
    if (typeof window.gtag === 'function') {
      const params = Object.assign({}, payload);
      // GA4 uses only params it knows; extras are ignored safely.
      if (eventName === 'select_promotion') {
        params.event_callback = cb || null;
        params.event_timeout  = 500;
      }
      window.gtag('event', eventName, params);
      if (eventName !== 'select_promotion' && cb) cb();
      return;
    }

    // Fallback: push to dataLayer; set up a GA4 Event tag in GTM to listen to these events
    if (Array.isArray(window.dataLayer)) {
      // Clear previous ecommerce (GA4 best practice)
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: eventName,           // 'view_promotion' or 'select_promotion'
        ecommerce: {
          items: payload.items,
          creative_name: payload.creative_name,
          creative_slot: payload.creative_slot,
          promotion_id: payload.promotion_id,
          promotion_name: payload.promotion_name,
          location_id: payload.location_id
        },
        page_type: payload.page_type,
        destination: payload.destination
      });
      if (cb) setTimeout(cb, 150);
      return;
    }

    // Last resort
    if (cb) cb();
    if (window.console && console.warn) {
      console.warn('[R2 Internal Ad] Neither gtag nor dataLayer found. Event not sent:', eventName);
    }
  }

  // Impression logic: count when >= 50% visible for ~1s; fire once per element
  function setupImpressionObserver(ads){
    if (!('IntersectionObserver' in window)) {
      // Fallback: fire immediately
      ads.forEach(el => {
        if (seen.has(el)) return;
        seen.add(el);
        trackGA4('view_promotion', getPayload(el));
      });
      return;
    }

    const timers = new WeakMap();
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const el = entry.target;
        if (seen.has(el)) return;

        if (entry.intersectionRatio >= 0.5) {
          if (!timers.has(el)) {
            const t = setTimeout(() => {
              if (seen.has(el)) return;
              seen.add(el);
              trackGA4('view_promotion', getPayload(el));
              timers.delete(el);
            }, 1000);
            timers.set(el, t);
          }
        } else {
          const t = timers.get(el);
          if (t) { clearTimeout(t); timers.delete(el); }
        }
      });
    }, { threshold: [0, 0.5, 1] });

    ads.forEach(el => io.observe(el));
  }

  function setupClickTracking(ads){
    ads.forEach(el => {
      el.addEventListener('click', (e) => {
        // Find nearest link inside the ad
        const a = e.target.closest('a');
        const href = a && a.getAttribute('href');
        const payload = getPayload(el);

        if (href && !href.startsWith('#')) {
          e.preventDefault();
          trackGA4('select_promotion', payload, () => { window.location.href = href; });
        } else {
          trackGA4('select_promotion', payload);
        }
      }, { capture: true });
    });
  }

  ready(() => {
    const ads = Array.from(document.querySelectorAll('.r2-internal-ad'));
    if (!ads.length) return;
    setupImpressionObserver(ads);
    setupClickTracking(ads);
  });
})();
